// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage  } from "firebase/storage";
import { getFirestore } from "firebase/firestore"

import firebase from "firebase/compat/app"
import "firebase/compat/storage"
import "firebase/compat/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBMeS9azfLqXhM8JHVo6oNYjrlLfPqAvVw",
  authDomain: "crud-react-d1e99.firebaseapp.com",
  projectId: "crud-react-d1e99",
  storageBucket: "crud-react-d1e99.appspot.com",
  messagingSenderId: "844171082548",
  appId: "1:844171082548:web:4af08a7a4d36dccb2b4361"
};

// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const imgDb = getStorage (app);
export const db = getFirestore(app)